export default function () {
    var style = '';
    if ($('body').hasClass('herald-boxed')) {
        style = '.herald-no-sid .alignfull { width: ' + $('.herald-site-content').outerWidth() + 'px; margin-left: -' + $('.herald-site-content').outerWidth() / 2 + 'px; margin-right: -' + $('.herald-site-content').outerWidth() / 2 + 'px; left:50%; right:50%;max-width: none; }';
        if ($('#herald-full-fix').length) {
            $('#herald-full-fix').html(style);
        } else {
            $('head').append('<style id="herald-full-fix" type="text/css">' + style + '</style>');
        }
    } else {
        style = '.herald-no-sid .alignfull { width: ' + $(window).width() + 'px; margin-left: -' + $(window).width() / 2 + 'px; margin-right: -' + $(window).width() / 2 + 'px; left:50%; right:50%;max-width: none; }';
        if ($('#herald-align-fix').length) {
            $('#herald-align-fix').html(style);
        } else {
            $('head').append('<style id="herald-align-fix" type="text/css">' + style + '</style>');
        }
    }
}
